import { QueryClient } from "@tanstack/react-query";

/**
 * Centralized TanStack Query client.
 *
 * Retry policy:
 * - dashboard login mutations: 5 attempts total (4 retries), no further retries after that
 * - all other queries/mutations: 1 retry (2 total attempts)
 *
 * The dashboard login retry count is enforced separately inside
 * DashboardLoginContext; here we set the global default to 1 retry.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      retryDelay: (attempt) => Math.min(500 * (attempt + 1), 5000),
      staleTime: 30_000,
      refetchOnWindowFocus: false,
    },
    mutations: {
      retry: 1,
      retryDelay: (attempt) => Math.min(500 * (attempt + 1), 5000),
    },
  },
});
